import React, { useState } from 'react';
import { Box, Alert, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon, Construction as ConstructionIcon } from '@mui/icons-material';

const BANNER_HEIGHT = 48;

const DevelopmentBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <>
      {/* Fixed banner at top */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
        }}
      >
        <Alert
          severity="warning"
          sx={{
            borderRadius: 0,
            py: 0.5,
            minHeight: BANNER_HEIGHT,
            '& .MuiAlert-message': {
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            '& .MuiAlert-action': {
              position: 'absolute',
              right: 8,
            }
          }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => setIsVisible(false)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <ConstructionIcon fontSize="small" />
            <Typography variant="body2" fontWeight="medium">
              AutoReelr is currently under development - Coming Soon!
            </Typography>
          </Box>
        </Alert>
      </Box>
      {/* Spacer to push content down */}
      <Box sx={{ height: BANNER_HEIGHT }} />
    </>
  );
};

export default DevelopmentBanner;